import React, {Component} from 'react';
import {Form} from 'semantic-ui-react'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import {arrayToCombo} from '../../Helpers'
import PropTypes from 'prop-types';

class DocumentCreatorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            divisione: props.idDivisione,
            tipoDocumento: props.codiceTipoDocumento,
            dropdownDivisioniLoading: false,
            dropdownTipiDocumentoLoading: false,
            divisioniList: [],
            tipiDocumentoList: [],
            fields: {
                idDivisione: props.idDivisione,
                codiceTipoDocumento: props.codiceTipoDocumento,
                anno: props.anno,
            },
            error: null,
            inError: false,
        };
        this.comboDivisioni = this.comboDivisioni.bind(this)
        this.comboTipiDocumento = this.comboTipiDocumento.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
    }

    componentWillMount() {
        // Carica gli elenchi base
        this.comboDivisioni();
        this.comboTipiDocumento();
    }

    onInputChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });

            if (this.props.onChange !== undefined){
                this.props.onChange(this.state.fields )
            }
        }
    }

    comboDivisioni(){
        this.setState({ dropdownDivisioniLoading: true });
        client.loadDivisioniList(
            10000, 1,{field:'nome', direction:'A'}, undefined,
            this.props.inRubrica, this.props.inCommesse, this.props.inGare
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        dropdownDivisioniLoading: false,
                        error: null,
                        divisioniList: arrayToCombo(data.items, "idDivisione", "nome", "idDivisione")
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        dropdownDivisioniLoading: false,
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            this.setState({
                dropdownDivisioniLoading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    comboTipiDocumento(){
        this.setState({ dropdownTipiDocumentoLoading: true });
        client.loadTipiDocumentoList(
            10000, 1,{field:'nome', direction:'A'}, undefined,
            this.props.inRubrica, this.props.inCommesse, this.props.inGare
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        dropdownTipiDocumentoLoading: false,
                        error: null,
                        tipiDocumentoList: arrayToCombo(data.items, "codiceTipoDocumento", "nome", "codiceTipoDocumento")
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        dropdownTipiDocumentoLoading: false,
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            this.setState({
                dropdownDivisioniLoading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        return (
            <div className="ui grid one column">

                <div className="column">
                    <Form.Group widths="1">
                        <Form.Dropdown width={16} loading={this.state.dropdownDivisioniLoading} label='Divisione' name='idDivisione' fluid search selection options={this.state.divisioniList} value={this.state.fields.idDivisione}
                                       onChange={this.onInputChange} />
                    </Form.Group>
                    <Form.Group widths="1">
                        <Form.Dropdown width={16} loading={this.state.dropdownTipiDocumentoLoading} label='Tipo Documento' name='codiceTipoDocumento' fluid search selection options={this.state.tipiDocumentoList} value={this.state.fields.codiceTipoDocumento}
                                       onChange={this.onInputChange} />
                    </Form.Group>
                    <Form.Group widths="1">
                        <Form.Input width={16}  label='Anno di riferimento' placeholder='AAAA' name='anno' autoComplete="on"  pattern="[0-9][0-9][0-9][0-9]"  fluid value={this.state.fields.anno} onChange={this.onInputChange}/>
                    </Form.Group>

                </div>
            </div>

            )
    }
}

DocumentCreatorForm.PropTypes = {
    codiceTipoDocumento: PropTypes.string,
    idDivisione: PropTypes.number,
    inRubrica: PropTypes.bool,
    inCommesse: PropTypes.bool,
    inGare: PropTypes.bool,
    onChange: PropTypes.func,
}

DocumentCreatorForm.defaultProps = {
    inRubrica: false,
    inCommesse: false,
    inGare: false
};

DocumentCreatorForm.contextTypes = {
    router: PropTypes.object
}

export default DocumentCreatorForm;



/** WEBPACK FOOTER **
 ** ./src/components/documenti/DocumentCreatorForm.js
 **/